import React, { useEffect, useState } from 'react';
import { BreathAPIs } from '../APIs/BreathAPIs';
import styles from './styles.module.css';
import { Container} from 'react-bootstrap';
import { toast, ToastContainer } from 'react-toastify';
import { Table, Button, Modal, Form, Input, Row, Col, Switch, Checkbox,Select,Radio, ConfigProvider } from 'antd';
import { IoMdCloseCircle } from 'react-icons/io';
import { MinusCircleOutlined, PlusCircleOutlined, CloseOutlined } from "@ant-design/icons";
import RichTextEditor from '../components/RichTextEditor';

const { TextArea } = Input;

const EmailBroadcast = () => {

    const [isLoading, setIsLoading] = useState({locations:true,users:true,sendEmail:false});
    const [selectedLocation, setSelectedLocation] = useState(null)
    const [allLocations, setAllLocations] = useState([]);
    const [users,setUsers] = useState([]);
    const [pagination, setPagination] = useState({
            total: 0,
            current: 1,
            pageSize: 10,
            totalPages: 0
        });
    const [selectedUsersPagination, setselectedUsersPagination] = useState({
            total: 0,
            current: 1,
            pageSize: 10,
            totalPages: 0
        });
    const emailString ='Dear firstName,' + "<br/><br/>Best," + "<br/>BreatheEV"

    const [filterText, setFilterText] = useState('');
    const [selectedUsers, setSelectedUsers] = useState([]);
    const [showAvailableUsers,setShowAvailableUsers] = useState(true);
    const [emailSubject,setEmailSubject] = useState('');
    const [emailBody,setEmailBody] = useState(emailString);
    const [selectAllUsers,setSelectAllUsers] = useState(true)
    const [selectAllUsersAlt,setSelectAllUsersAlt] = useState(true);
    const [totalSelectedusersCount,setTotalSelectedUsersCount] = useState(0);
    const [altSelectedUsers,setAltSelectedUsers] = useState([]);
    

    useEffect(() => {
        getAllLocations();
        getUsers()
        }, []);
    
    useEffect(()=>{
        if(selectAllUsers){
            setTotalSelectedUsersCount(pagination.total)
            setSelectedUsers(users);
            setselectedUsersPagination(pagination)
        }
        else{

            setTotalSelectedUsersCount(0);
            setSelectedUsers([])
            setAltSelectedUsers([])
            setselectedUsersPagination({
            total: 0,
            current: 1,
            pageSize: 10,
            totalPages: 0
        })
        getUsers(1,10);
        setShowAvailableUsers(true)
        }
        
    },[selectAllUsers,pagination.total,selectedLocation])

    useEffect(()=>{
        if( (totalSelectedusersCount < pagination.total) && selectAllUsersAlt ){
        // if( (totalSelectedusersCount < selectedUsersPagination.total) && selectAllUsersAlt ){
            setSelectAllUsersAlt(false)
        }
        if ((totalSelectedusersCount === 0) && selectAllUsers && (!selectAllUsersAlt)){
            setSelectAllUsers(false)
        }
        if ((totalSelectedusersCount === pagination.total) && selectAllUsers){
        //  if ((totalSelectedusersCount === selectedUsersPagination.total) && selectAllUsers){
            setSelectAllUsersAlt(true)
        }
        if((totalSelectedusersCount === pagination.total) && (!selectAllUsers) && (!selectAllUsersAlt)){
            setSelectAllUsers(true);
            setSelectAllUsersAlt(true);
        }
    },[totalSelectedusersCount])

   
    
        const handleTableChange = (pagination) => {
        const { current, pageSize } = pagination;
        getUsers(current, pageSize);
    };
      const handleSelectedUsersTableChange = (pagination) => {       
        const { current, pageSize } = pagination;

        setselectedUsersPagination((prev)=>{
            return {
                ...prev,current:current,pageSize:pageSize
            }
        })
        if(selectAllUsers){
            getUsers(current,pageSize)
        }
    };

    const getAllLocations = async () => {
            try {
                setIsLoading((prev)=>{
                    return {...prev, locations:true}
                })
                const result = await BreathAPIs.getAllLocations();
                setAllLocations(result.data)
                 setIsLoading((prev)=>{
                    return {...prev, locations:false}
                })

            } catch (error) {
                console.log("Error in getting all locations", error.message)
                toast.error('error fetching locations')
                 setIsLoading((prev)=>{
                    return {...prev, locations:false}
                })
            }
        }

    // const handleFilter = ()=>{
    //     if(selectedLocation && !selectAllUsers){
    //         setSelectAllUsers(true);
    //     }
    //     getUsers()
    // }
    
    const handleClearFilter = () => {
        if(!selectAllUsers){
            setSelectAllUsers(true);
            setSelectAllUsersAlt(true);
        }
    setSelectAllUsersAlt(true)
    setSelectedLocation(null)
    setFilterText('');
    // setSelectedUsers([])
    // setAltSelectedUsers([])
    setShowAvailableUsers(true)
    getUsers(1, 10, true);
    };

    const handleSwitch = (value)=>{
        if(selectAllUsers && !selectAllUsersAlt){
            setAltSelectedUsers([])
            setTotalSelectedUsersCount(pagination.total)
            setSelectedUsers(users);
            // setselectedUsersPagination(pagination)


        }
        setSelectAllUsers(value);
        setSelectAllUsersAlt(value);
    }

    
  const handleLocationChange = (value)=>{
    if ( !selectAllUsers){
        setSelectAllUsers(true)
    }
    if(!showAvailableUsers){
        setShowAvailableUsers(true);
    }
    getUsers(1,10,false,value)
  }
    
    
    const getUsers = async (page = 1, pageSize = 10, withoutFilter = false,updatedSelectedLocation=null) => {
         setIsLoading((prev)=>{
                    return {...prev, users:true}
                })
        try {
            
            let res;
            // HANDLE SHARED-PUBLIC AND SHARED-PRIVATE USERS
          
            if ((selectedLocation || updatedSelectedLocation) && (!withoutFilter) && (updatedSelectedLocation ? (allLocations.find((loc) => loc._id === updatedSelectedLocation).locationType === 'PUBLIC') : ((allLocations.find((loc) => loc._id === selectedLocation).locationType === 'PUBLIC')))) 
            {
                console.log('inside public location block ( updated selectedlocation ) : ',updatedSelectedLocation)
                console.log('inside public location block (  selectedlocation ) : ',selectedLocation)

                res = await BreathAPIs.getPublicUsers({ page, limit: pageSize,filterText: filterText ? filterText : null, locationId:updatedSelectedLocation?([updatedSelectedLocation]):([selectedLocation])});
                // console.log('res for public users: ',res);
                setUsers(res.data.users)
            }
            else{
                console.log('inside private location block ( updated selectedlocation ) : ',updatedSelectedLocation)
                console.log('inside private location block (  selectedlocation ) : ',selectedLocation)
                res = await BreathAPIs.getUserList(withoutFilter ? { page: 1, limit: 10 } : { page, limit: pageSize, filterText: filterText ? filterText : null,filterLocation:updatedSelectedLocation?[updatedSelectedLocation]:selectedLocation?[selectedLocation]:null });
                // console.log('res for all other locations: ',res);
                setUsers(res.data.users);

                if(withoutFilter){
                    setTotalSelectedUsersCount(res.data.pagination.total);
                }
            }

            if(selectAllUsers){

                if(withoutFilter){
                    setSelectedUsers(res.data.users);
                    setAltSelectedUsers([]);

                }
                else{

                    if(altSelectedUsers.length > 0){
                        setSelectedUsers(res.data.users.filter((user)=>{
                            const founduser = altSelectedUsers.find((altSelectedUser)=>altSelectedUser._id===user._id);
                            if(!founduser){
                                return user
                            }
                        }))
                    }
                    else{
    
                        setSelectedUsers(res.data.users);
                    }
                }

                
                setselectedUsersPagination({
                total: res.data.pagination.total,
                current: res.data.pagination.current,
                pageSize: res.data.pagination.pageSize,
                totalPages: res.data.pagination.totalPages
            })
            }
            setPagination({
                total: res.data.pagination.total,
                current: res.data.pagination.current,
                pageSize: res.data.pagination.pageSize,
                totalPages: res.data.pagination.totalPages
            });
             setIsLoading((prev)=>{
                    return {...prev, users:false}
                })
        } catch (error) {
            console.error(error);
             setIsLoading((prev)=>{
                    return {...prev, users:false}
                })
            toast.error('Error fetching users');
        } 
    };

    const handleUsers = (user) => {

    const foundUser = selectedUsers.find((selectedUser) => selectedUser._id === user._id) 
    if(foundUser){

        setSelectedUsers((selectedUsers) => {
          return selectedUsers.filter((selectedUser) => selectedUser._id !== user._id)
        });
        setTotalSelectedUsersCount(totalSelectedusersCount - 1);
    }
    else{
        setSelectedUsers([...selectedUsers, user]);
        setTotalSelectedUsersCount(totalSelectedusersCount + 1);
    }
     
  }

  const handleAltUsers = (user) => {

    const founduser = altSelectedUsers.find((selectedUser) => selectedUser._id === user._id);
    if(founduser){
         setAltSelectedUsers((selectedUsers) => { return selectedUsers.filter((selectedUser) => selectedUser._id !== user._id) })
            setTotalSelectedUsersCount(totalSelectedusersCount + 1)

    }
    else{
         setAltSelectedUsers([...altSelectedUsers, user])
        setTotalSelectedUsersCount(totalSelectedusersCount - 1)
    }
    
  }


  const handleUsersViewChange = (value)=>{
    setShowAvailableUsers(value)
  }

  const sendEmail = async ()=>{
    try {

          setIsLoading((prev)=>{
                    return {...prev, sendEmail:true}
                })
        const recipients = (selectAllUsers?altSelectedUsers:selectedUsers).map((user)=>{
        return  {_id:user._id, firstName:user.firstName,lastName:user.lastName, email: user.email}
        })
        
       

        const res = await BreathAPIs.sendEmail({recipients:recipients,emailSubject:emailSubject,emailBody:emailBody,selectAllUsers:selectAllUsers,location:selectedLocation});
        if(res.data.success){
            toast.success(`${res.data.count} Email(s) sent`)
        }
        else{
            toast.error('Error while sending email(s)')
        }

        setIsLoading((prev)=>{
                    return {...prev, sendEmail:false}
                })
        
    } catch (error) {
        console.log('Error while sending email: ',error);
         setIsLoading((prev)=>{
                    return {...prev, sendEmail:false}
                })
        toast.error('Error while sending email')
    }
  }


     const columnUsers = [
         {
      render: (text, record) => (
        <ConfigProvider
        wave={{ disabled: true }}
        >

            <Button
              onClick={() => {
                handleUsers(record);
                (selectAllUsers && handleAltUsers(record));
              }}
              className={selectedUsers.find((selectedUser) => selectedUser._id === record._id) ? styles['removeButton'] : styles['addButton']}
              icon={selectedUsers.find((selectedUser) => selectedUser._id === record._id) ? <MinusCircleOutlined /> : <PlusCircleOutlined />}
    
            />
        </ConfigProvider>

      ),
      width: 15
    },
    
        {
            title: 'First Name',
            dataIndex: 'firstName',
            key: 'firstName',
            render: (text, record) => (
                <span> {record.firstName ? record.firstName : 'Not Available'}</span>
            ),
          
        },
        {
            title: 'Last Name',
            dataIndex: 'lastName',
            key: 'lastName',
            render: (text, record) => (
                <span> {record.lastName ? record.lastName : 'Not Available'}</span>
            ),
           
        },
        {
            title: 'Email',
            dataIndex: 'email',
            key: 'email',
        },
        {
            title: 'Contact',
            dataIndex: 'phone',
            key: 'phone',
            render: (text, record) => (
                <span> {record.phone? record.phone : 'Not Available'}</span>
            ),
        },
       
    
       
    ];


    return (
        <Container>
            <ToastContainer></ToastContainer>
            {console.log('selected location in main reload : ',selectedLocation)}
        {/* {console.log('selected users ',selectedUsers)}
        {console.log('select users alt',altSelectedUsers)} 
        {console.log('selected all users ',selectAllUsers)}
        {console.log('select all users alt',selectAllUsersAlt)} */}
            <div className={styles['filter']}>
                    <div className={styles['filter-left']}>
                    
                        <Select
                                                    showSearch
                                                    disabled={isLoading.locations}
                                                    // defaultValue="Select Location"
                                                    placeholder={'Select Location'}
                                                    style={{ width: '100%' }}
                                                    value={selectedLocation}
                                                    onChange={(value) => {
                                                        setSelectedLocation(value);
                                                        handleLocationChange(value); }}
                                                    // onSearch={onSearch}
                                                    // allowClear
                                                    options={allLocations.map(element => ({
                                                    value: element._id,
                                                    label: element.locationName
                                                    }))}
                                                    // onClear={() => setSelectedLocation(null)}
                                                    filterOption={(input, option) => 
                                                    option.label.toLowerCase().includes(input.toLowerCase()) // Custom filtering logic
                                                    }
                                                />
                    </div>
                    <div className={styles['filter-right']}>
                        {/* <Button 
                        onClick={() => { handleFilter() }}
                         type="primary">Filter</Button> */}
                        <Button 
                        onClick={()=>{handleClearFilter()}}  
                        className={styles['custom-btn']} type="primary" danger color='white' shape="circle" icon={<IoMdCloseCircle />} ></Button>
                    </div>
            </div>
            <div className={styles['btn-row']}>
                <div className={`${styles['flex-container']}`}>
                    <div >
                        <b>Select All Users</b>
                    </div>
                    <div >

                <Switch 
                checked={selectAllUsersAlt}
                onChange={(value)=>{handleSwitch(value)}}
                style={{marginLeft:'1rem'}}
                />
                    </div>
                </div>
                <div >
                {
                    (totalSelectedusersCount > 0) &&
                    <ConfigProvider wave={{disabled:true}}>
                    <span className={`${styles.selectedUsersCount}`} pill >
                <span >{`${totalSelectedusersCount} User(s) Selected`} 
                </span>
              </span>

                    {/* <Button
                    style={{marginRight:'10px'}}
                    >
                    {`${totalSelectedusersCount} User(s) Selected`}    
                        </Button> */}
                    </ConfigProvider>
                }
                    
            <Button 
            disabled={(emailBody.length===0) || (emailSubject.length===0) || (selectedUsers.length===0)} 
            onClick={()=>{sendEmail()}} 
            loading={isLoading.sendEmail}
            type='primary'>
                Send
            </Button>
                </div>
            </div>
            <div className={styles['flex-container']}>
                <div className={styles['third-row']}>
                <div className={styles['third-row-r1']}>
                    <Input 
                    
                    value={emailSubject} 
                    onChange={(e)=>{setEmailSubject(e.target.value)}} 
                    placeholder='Enter subject of the mail'/></div>
                <div className={styles['third-row-r2']} >
                        {/* <TextArea 
                        value={emailBody}
                        // rows={5}
                        // maxLength={'100%'}
                        onChange={(e)=>{setEmailBody(e.target.value)}}
                        style={{height:'100%'}}
                         placeholder="Enter text body of the mail"  /> */}
                        <RichTextEditor value={emailBody} onChange={setEmailBody}></RichTextEditor>

                    {/* <Input type='text' className={styles['email-body']} placeholder='Enter body of the mail'/> */}
                    </div>
                </div>
                <div className={styles['third-row-alt']}>
                    <div className={styles['third-row-r1']}>
                        <Radio.Group
                            style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
                            onChange={(event) => { handleUsersViewChange(event.target.value) }}
                            value={showAvailableUsers}
                        >
                            <Radio.Button style={{ width: '100%' }} value={true}>Available Users</Radio.Button>
                            <Radio.Button style={{ width: '100%' }} value={false}>Selected Users</Radio.Button>
                        </Radio.Group>
                    </div>
                    <div className={styles['third-row-r1-alt']}>
                            <Input 
                        value={filterText} 
                        placeholder='Search: Email, First Name, Last Name, Contact'
                         onChange={(e) => setFilterText(e.target.value)}
                          />
                          <Button className={styles['search-btn']} onClick={()=>{selectedLocation ? getUsers(1, 10, false, selectedLocation) : getUsers(1, 10, false)}}>Search</Button>
                         
                    </div>
                    <div className={styles['table-styling']}> 
                    {
                        showAvailableUsers?
                        <Table
                        
                          loading={isLoading.users}
                dataSource={users}
                columns={columnUsers}
                rowKey="_id"
                pagination={pagination}
                onChange={handleTableChange}
                
                bordered
                size="middle"
                scroll={{ x: 'calc(600px + 50%)'}}
                onRow={(record) => ({
                  style: selectedUsers.some((selectedUser) => selectedUser._id === record._id)
                    ? { backgroundColor: '#e6f7ff' }  // light blue
                    : {},
                })}
                        />
                        :
                        <Table
                            loading={selectAllUsers && isLoading.users}
                           dataSource={selectedUsers}
                            columns={columnUsers}
                            rowKey="_id"
                            
                            bordered
                            size="middle"
                            scroll={{ x: 'calc(600px + 50%)'}}
                            pagination={selectedUsersPagination}
                            onChange={handleSelectedUsersTableChange}

                            
                        />

                    }

                    </div>
                </div>
            </div>
        </Container>
    );
}

export default EmailBroadcast;
